// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__5olss","contact_sales":"style_contact_sales__5dhvY"};